module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "country-popup"
  }, [_c('h4', {
    staticClass: "country-popup__heading"
  }, [_vm._v("\n    " + _vm._s(_vm.display) + "\n  ")]), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "country-popup__text"
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]) : _c('div', {
    staticClass: "p-3"
  }, [_vm._v("\n    There is no data for this country\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "country-popup__body"
  }, [(_vm.variables.length > 0) ? _c('div', [_c('dl', {
    staticClass: "row mb-0"
  }, [_vm._l((_vm.variables), function(variable) {
    return [_c('dt', {
      staticClass: "col-sm-6 text-sm-right text-nowrap"
    }, [_vm._v(_vm._s(_vm.getVariable(variable).label))]), _vm._v(" "), _c('dd', {
      staticClass: "col-sm-6"
    }, [_vm._v(_vm._s(_vm.data[variable]))])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row country-popup__body__nav with-tip"
  }, [(_vm.previous !== null) ? _c('button', {
    staticClass: "btn btn-primary col",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openCountryPopup(_vm.previous.iso3)
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous country")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-left"
  })]) : _vm._e(), _vm._v(" "), (_vm.next !== null) ? _c('button', {
    staticClass: "btn btn-primary col",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openCountryPopup(_vm.next.iso3)
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next country")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })]) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a94082","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CountryPopup.vue
// module id = 768
// module chunks = 1